import firebase from 'firebase/app';
import 'firebase/firestore';

try{
    const config = {
				apiKey: "AIzaSyBVsqntNwabj-PSrar6zRGhOmecuGVTuhk",
        authDomain: "springshotelperu.firebaseapp.com",
        databaseURL: "https://springshotel.firebaseio.com",
        projectId: "springshotelperu",
        storageBucket: "springshotelperu.appspot.com",
        messagingSenderId: "814769462557",
    }
    firebase.initializeApp(config)
}catch (error) {
    if(!/already exists/.test(error.message)){
        console.log(`Firebase didn't initialize correctly : ${error.message}`)
    }
}
export default firebase
